/* @flow */

import { getEventPlugins, getEventFeatures } from '@e180/domain/lib/event/util';
import { assertString, assertObject } from '@e180/util/lib/assert';

import featureConfig from 'src/shared/app/feature/config/featureConfig';

import type { BraindateEvent } from '@e180/domain/lib/event/type';

export function isPluginActivatedInObject(id: string, obj: Object): boolean {
  assertString(id, 'id');
  assertObject(obj, 'obj');

  let flag = false;

  for (const [key, value] of Object.entries(obj)) {
    if (key === id && value) {
      flag = true;

      break;
    }
  }

  return flag;
}

export function isPluginEnabled(id: string, event: BraindateEvent): boolean {
  assertString(id, 'id');
  assertObject(event, 'event');

  return isPluginActivatedInObject(id, {
    ...featureConfig,
    ...getEventPlugins(event),
    ...getEventFeatures(event),
  });
}
